// extracted by mini-css-extract-plugin
export var attachment = "_rh-a";
export var emailContainer = "_rh-4";
export var emailContentPaddedContainer = "_rh-b";
export var emailHeader = "_rh-6";
export var emailIframe = "_rh-3";
export var emailInfoIcon = "_rh-9";
export var emailShortenedSummary = "_rh-e";
export var infoDropdown = "_rh-0";
export var infoRowBoundedContent = "_rh-d";
export var internal = "_rh-5";
export var merchant = "_rh-8";
export var messageInputContainer = "_rh-h";
export var normal = "_rh-7";
export var replyCard = "_rh-f";
export var subtleButton = "_rh-1";
export var subtleButtonIconContainer = "_rh-2";
export var toggleViewRepliesButton = "_rh-c";
export var wrappingText = "_rh-g";